export default __webpack_public_path__ + "fd783acba016a65459a0a190c48038f1.png";